<template>
  <RouterView />
</template>

<script setup>
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useTokenStore, useEnvStore } from '@/stores'
import { getHttpsAddress } from '@/utils/index'
import { detectEnvironment, getPlatform } from '@/utils/env'  // 引入环境检测

const { setToken, setRefreshtoken } = useTokenStore()
const { setEnv, removeAll } = useEnvStore()

const router = useRouter()
const route = useRoute()

// 直接在 H5 根节点上强力监听路由变化，并高频穿透发送给 App
watch(
  () => route.path,
  (newPath) => {
    if (!newPath) return

    // 定义根主页
    const rootPaths = ['/', '/home', '/login']
    const isRootPage = rootPaths.includes(newPath)
    const needAppIntercept = !isRootPage

    // 采用双重保障：多发几次，或者延迟确保 window.uni 100% 就绪
    const sendMsg = () => {
      if (window.uni && typeof window.uni.postMessage === 'function') {
        window.uni.postMessage({
          data: {
            action: 'updateHistory',
            canBack: needAppIntercept,
            currentPath: newPath
          }
        })
        console.log(`🚀 [H5根节点上报成功] 路径: ${newPath} | 拦截状态: ${needAppIntercept}`)
      } else {
        console.warn('⚠️ [H5监控] window.uni 暂未就绪，50ms 后重试...')
      }
    }

    // 路由一变，立刻入队异步通道发送
    setTimeout(sendMsg, 50)
    setTimeout(sendMsg, 200) // 200ms 再补发一次，防止异步分包加载导致的通道被吞
  },
  { immediate: true }
)

onMounted(() => {
  removeAll()
  // 获取网址中的token参数的值
  const token = new URL(window.location.href).searchParams.get('token')
  const refreshtoken = new URL(window.location.href).searchParams.get('refreshtoken')
  const env = new URL(window.location.href).searchParams.get('env')

  getHttpsAddress()

  if (token) {
    setEnv('mp')
    // 存储token
    localStorage.setItem('userToken', JSON.stringify({ token, refreshtoken }))
    setToken(token)
    setRefreshtoken(refreshtoken)
  } else if (env == 'js') {
    setEnv('js')
    router.push({ path: '/login' })
  } else {
    // 默认设置为网页环境
    setEnv('js')
  }





  // // 检测运行环境
  // const utilsEnv = detectEnvironment()
  // console.log('🚀 ~ 运行环境:', utilsEnv)
  // console.log('🚀 ~ 平台标识:', getPlatform())
  // // alert(getPlatform())

  // // 根据环境执行不同逻辑
  // if (utilsEnv.isWechatMiniprogram) {
  //   console.log('当前在微信小程序环境中')
  //   // alert('当前在微信小程序环境中')
  //   setEnv('mp')
  //   // 小程序特有逻辑
  // } else if (utilsEnv.isApp) {
  //   console.log('当前在 APP 环境中')
  //   // alert('当前在 APP 环境中')
  //   setEnv('app')
  //   // APP 特有逻辑
  // } else {

  //   // 网页特有逻辑
  // }



  // 林
  // const token =
  //   'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySnNvbiI6IntcImlkXCI6NDAsXCJwbGF0Zm9ybUNvbnN0YW50XCI6XCJXRUNIQVRfUFJPR1JBTVwiLFwiZXhwaXJlc0F0XCI6MTc2Njk5MjUzMTU5MyxcInJlbWVtYmVyXCI6dHJ1ZX0iLCJleHAiOjE3NjY5OTI1MzF9.SJ8fONy2uk3Qk2jf0q5TC8g7m6RHqTv7lWkEq6sH5kM4FB13sBImfjOK1zu50nKo4kmWFPGHvUidynEkuThfew'
  // const refreshtoken = 'feca5cdbb9448e752a73f7632b3b6b8e'

  // 沈
  // const token =
  //   'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySnNvbiI6IntcImlkXCI6MzksXCJwbGF0Zm9ybUNvbnN0YW50XCI6XCJXRUNIQVRfUFJPR1JBTVwiLFwiZXhwaXJlc0F0XCI6MTc2Njg0MDczODYwNixcInJlbWVtYmVyXCI6dHJ1ZSxcIm51bWVueElkXCI6XCJOTTAxMjUxMjI0MDAwMDEwXCJ9IiwiZXhwIjoxNzY2ODQwNzM4fQ.9js_ggtg9hAy51kQg_ib9kznBZMrrBp9B9y4-OsKWo6BwsMM3LvUrIPVGNvU_7qXpTAUzaD_Dx_aQN_ze6Dqiw'
  // const refreshtoken = '8b39aa37afccb71328cd142351eea638'

})
</script>

<style scoped lang="scss"></style>
